/**
 * LLM alert summary written by the backend into raw_payload.alert_summary
 * shortly after ingest (backend/internal/ams/alert_summary.go).
 */

interface AlertSummarySource {
  created_at?: string | null;
  raw_payload?: Record<string, unknown> | null;
}

/** Window after ingest in which the summary may still arrive. */
export const ALERT_SUMMARY_WAIT_MS = 2 * 60_000;
export const ALERT_SUMMARY_POLL_MS = 5_000;

export function generatedAlertSummary(incident: AlertSummarySource | null | undefined): string {
  const v = incident?.raw_payload?.alert_summary;
  return typeof v === 'string' ? v.trim() : '';
}

/** Poll interval while a recent incident still lacks its summary, else false. */
export function alertSummaryPollInterval(
  incident: AlertSummarySource | null | undefined,
  now: number = Date.now(),
): number | false {
  if (!incident || generatedAlertSummary(incident)) return false;
  const created = incident.created_at ? Date.parse(incident.created_at) : NaN;
  if (!Number.isFinite(created) || now - created > ALERT_SUMMARY_WAIT_MS) return false;
  return ALERT_SUMMARY_POLL_MS;
}

/** True while a recent incident may still receive its LLM summary. */
export function alertSummaryPending(
  incident: AlertSummarySource | null | undefined,
  now: number = Date.now(),
): boolean {
  return alertSummaryPollInterval(incident, now) !== false;
}
